<template>
  <div id="DefaultRequest" >
    <Header></Header>
    <router-view class="default-request" :class="{ 'jp': $i18n.locale === 'jp' }"></router-view>
  </div>
</template>

<script>
import Header from '../components/Header.vue'

export default {
  components: {
    Header
  }
}
</script>

<style lang="scss">
.default-request {
  font-family: 'NanumSquare', sans-serif;
}

.jp {
  
}
</style>